/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Editor_EmptyInputs */

const en_statement_taxonomy_editor_empty = /** @type {(inputs: Statement_Taxonomy_Editor_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No rows in this statement yet.`)
};

const nl_statement_taxonomy_editor_empty = /** @type {(inputs: Statement_Taxonomy_Editor_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze staat bevat nog geen regels.`)
};

/**
* | output |
* | --- |
* | "No rows in this statement yet." |
*
* @param {Statement_Taxonomy_Editor_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_editor_empty = /** @type {((inputs?: Statement_Taxonomy_Editor_EmptyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Editor_EmptyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_editor_empty(inputs)
	return en_statement_taxonomy_editor_empty(inputs)
});